<template>
  <div>
    <div class="flexc-cen-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{WZXMName}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
                <el-option
                        v-for="item in DianList"
                        :key="item.ID"
                        :label="item.StoresName"
                        :value="item.ID">
                </el-option>
            </el-select>
    </div>
      <el-container style="padding-top:15px">
          <el-aside width="210px" >
    <!-- 搜索筛选 -->
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-button size="medium" style="width:95%;" v-if="q1 == true"   type="primary" icon="el-icon-plus" @click="handlePassword()">添加{{WZXMName}}类别</el-button>
            </el-form>
            <div class="title flexc-cen-x cursor"  @click="toAll()"> 
                <div style="margin-left:10px">所有类别<i class="el-icon-refresh-left"  style="margin-left:110px;font-size:18px"></i> </div>
            </div>
            <div style="height:63vh;overflow:auto;">
              <div class="css" v-for="(item,index) in typeList" style="width:95%;margin-top:20px;margin-bottom:2px" >
                <div v-if="item.ID == active" class="flex-xy  cursor shadow" id="shadw" style="width:96%;margin-left:2%;border-radius:5px;border:1px solid #409EFF">
                    <div style="width:95%;padding-top:10px;padding-bottom:10px">
                        <div class="flex-spc-x">
                            <div class="flexc-cen-x">
                                <i class="el-icon-s-unfold"></i>
                                <div style="font-size:15px;margin-left:7px">{{item.SiteTypeName}}</div>
                            </div>
                        </div>
                        <div class="flex-r-x" style="margin-top:10px">
                          <!-- <div class="xiang">{{item.allStaffcount}}位</div> -->
                            <div class="flexc-cen-x">
                               <i class="el-icon-edit" style="color:white" v-if="q2 == false"></i>
                                <i class="el-icon-edit" style="color:#808080" v-if="q2 == true" @click="handlePassword(item)"></i>
                                <!-- <i class="el-icon-document-copy" style="color:#808080;margin-left:10px"></i> -->
                                <i class="el-icon-delete" style="color:#808080;margin-left:10px" v-if="q3 ==true" @click="toDel(item)"></i>
                            </div>
                        </div>
                    </div>
 
                </div>
                <div v-if="item.ID != active" class="flex-xy cursor shadow" id="shadw" style="width:96%;margin-left:2%;border-radius:5px">
                    <div style="width:95%;padding-top:10px;padding-bottom:10px">
                        <div class="flex-spc-x" @click="toChoose(item)" > 
                            <div class="flexc-cen-x">
                                <i class="el-icon-s-unfold"></i>
                                <div style="font-size:15px;margin-left:7px">{{item.SiteTypeName}}</div>
                            </div>
                        </div>
                        <div class="flex-spc-x" >
                          <div class="" @click="toChoose(item)" style="width:250px;height:16px;padding-top:10px"></div>
                            <div class="flexc-cen-x" style="padding-top:10px">
                                <i class="el-icon-edit" style="color:#808080" v-if="q2 == true" @click="handlePassword(item)"></i>
                                <!-- <i class="el-icon-document-copy" style="color:#808080;margin-left:10px"></i> -->
                                <i class="el-icon-delete" style="color:#808080;margin-left:10px" v-if="q3 ==true" @click="toDel(item)"></i>
                            </div>
                        </div>
                    </div>
 
                </div>
              </div>
            </div>
        </el-aside>
           <el-main>
               <div class="flex-spc-x" style="width:100%;">
                 <div class="padding-left:5px" style="font-size:15px"> </div>
                 <div><el-button size="mini" type="primary" icon="el-icon-plus" v-if="q4 ==true" @click="handleEdit()">添加{{WZXMName}}</el-button>
                  <!-- <el-button size="mini" type="success" v-if="tableData.length > 1 && q7 == true" @click="toSort()">排序</el-button> -->
                  </div>
             </div>
          <div  style="margin-top:30px;width:100%;">
            
               <div class="flex-xy" v-if="tableData.length == 0">
                 <img src="../../assets/zanwu.png" alt="" style="width:100px;height:100px">
                 <div style="margin-top:20px;color:#808080">暂无数据</div>
               </div>
               <div class="box cursor flex-xy" v-for="(items,index) in tableData" @click="handleEdit(items)">
                 <div class="offline___NHq4e">{{items.SiteTypeName}}</div>
                  <div class="main" style="width:100%;margin-top:3px">
                       <div class="flexc-cen-x" style="width:100%">
                         <img :src="items.HeadUrl" alt="" style="width:70px;height:70px;border-radius:5px">
                         <div style="margin-left:10px">
                            <div class="titleMain" style="font-size:18px">
                              {{items.SiteName}}
                            </div>
                            <div class="content" style="margin-top:5px;">
                              <div>时长:{{items.Timelength}}分钟/{{items.TimelengthAmount}}元</div>
                              <div v-if="items.isPay == 1">定金:¥{{items.PayAmount}}</div>
                            </div>
                         </div>
                        
                       </div> 


                  </div>
               </div>
                
          </div>
           </el-main>
      </el-container>


    <!--列表-->

    <!-- 分页组件 -->
    
    <!-- 编辑界面 -->
     <el-drawer :wrapperClosable= false title="排序" :visible.sync="sortSure" :direction="direction" size="30%">
       <div style="width:100%;height:80vh;overflow:auto">
          <div  v-for="(item,index) in tableData" class="heng flex-xy" style="width:80%">
          <div class="flex-spc-x" style="width:99%">
            <div class="flexc-cen-x">
              <img :src="item.HeadUrl" v-if="item.HeadUrl !='' " style="width:40px;height:40px;border-radius:100%" alt="">
              <img v-if="item.HeadUrl =='' " src="../../assets/img/head.png" style="width:40px;height:40px;border-radius:100%" alt="">
                    <div style="font-size:15px;margin-left:5px">{{item.SiteName}}</div>
            </div>
            <div>
              <el-button v-show="index !=0" size="mini" icon="el-icon-top"  type="primary" plain @click="toTop(item)">升序</el-button>
              <el-button  v-show="index != tableData.length - 1 " size="mini" icon="el-icon-bottom" type="success" plain @click="toDown(item)">降序</el-button>
            </div>
          </div>
          </div> 
       </div>
       
        <div class="demo-drawer__footer flex-r-x" style="width:30%">
            <el-button size="small" @click="closeDialog">取消</el-button>
            <el-button
            style="margin-right:20px"
              size="small"
              type="primary"
              @click="closeDialog"
              >确定</el-button
            >
        </div>
     </el-drawer>


    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="40%">
      <el-tabs v-model="activeName"  style="padding-left:10px;padding-right:10px;padding-bottom:150px">
        <el-tab-pane label="基础配置" name="first">      
        <el-form label-width="140px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item :label="WZXMName+'名称:'" prop="SiteName">
          <el-input size="small" v-model="editForm.SiteName" auto-complete="off" placeholder="请输入名称"  style="width: 215px"></el-input>
        </el-form-item>

          <el-form-item :label="WZXMName+'类别:'" prop="SiteTypeID" >
            <el-select v-model="editForm.SiteTypeID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in typeList"
                  :key="item.ID"
                  :label="item.SiteTypeName"
                  :value="item.ID">
                </el-option>
              </el-select>
              <el-button type="text" @click="toSetting">设置</el-button>
           </el-form-item>
          
          <el-form-item :label="WZXMName+'分辨图:'" prop="HeadUrl">
                <div class="list-img-box cursor">
                  <div v-if="editForm.HeadUrl !== ''">
                    <img
                      :src="editForm.HeadUrl"
                      style="width: 100px; height: 100px"
                      alt="图片"
                        @click="uploadPicture('HeadUrl')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('HeadUrl')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                     <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>

                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="editForm.HeadUrl"
                  placeholder="请添加头像"
                />
          </el-form-item>
          <!-- <el-form-item :label="WZXMName+'种类:'" v-if="title == '添加' && RowTypeList.length != 1"  prop="RowTypeID">
            <el-select v-model="editForm.RowTypeID"  placeholder="请选择" size="small">
                  <el-option
                    v-for="item in RowTypeList"
                    :key="item.ID"
                    :label="item.RowTypeName"
                    :value="item.ID">
                  </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="WZXMName+'种类:'" v-if="title == '修改' && RowTypeList.length != 1"  prop="RowTypeID">
            <el-select v-model="editForm.RowTypeID" disabled  placeholder="请选择" size="small">
                  <el-option
                    v-for="item in RowTypeList"
                    :key="item.ID"
                    :label="item.RowTypeName"
                    :value="item.ID">
                  </el-option>
            </el-select>
          </el-form-item> -->

          <!-- <el-form-item :label="WZXMName+'颜色:'" prop="color">         
            <div class="bgColor flexc-cen-x" :style="{'background':editForm.color,}" @click="toColor">
                <i class="el-icon-arrow-down" style="margin-left:90%"></i>
            </div>
          </el-form-item> -->
          <el-form-item label="关联卡种:" prop="CardIDs" v-if="isCard == 1">
            <el-select v-model="editForm.CardIDs" multiple placeholder="请选择" size="small" style="width:90%">
              <el-option
                v-for="item in cardList"
                :key="item.ID"
                :label="item.CardName"
                :value="item.ID">
              </el-option>
            </el-select>
            <el-button type="text" @click="toCard">设置</el-button>
          </el-form-item>
          <div style="color:#b3b3b3;margin-top:-10px;margin-bottom:20px;margin-left:100px"> 如果不选择卡种，默认使用所有卡种。</div>
            <el-form-item label="是否支持无卡预约:" prop="iswkyy" v-if="isCard == 1" >
                <el-radio-group v-model="editForm.iswkyy">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="开启定金:" prop="isPay" v-if="IsPay == 1 && iscdyydx ==0" >
                <el-radio-group v-model="editForm.isPay">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="定金:" prop="PayAmount" v-if="editForm.isPay == 1 && iscdyydx ==0"  >
              <el-input size="small" v-model="editForm.PayAmount" type="number" auto-complete="off" placeholder="请输入价格"  style="width: 215px"></el-input> 元
            </el-form-item>
            <el-form-item label="开启线上支付:" prop="isPay" v-if="IsPay == 1 && iscdyydx ==1" >
                <el-radio-group v-model="editForm.isPay">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="支付金额:" prop="PayAmount" v-if="editForm.isPay == 1 && iscdyydx ==1"  >
              <el-input size="small" v-model="editForm.PayAmount" type="number" auto-complete="off" placeholder="请输入价格"  style="width: 215px"></el-input> 元
            </el-form-item>
                    <el-form-item label="开启不限时长" prop="isbxsc">
            <el-radio-group v-model="editForm.isbxsc">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="WZXMName+'时长:'" prop="Timelength">
          <el-input-number v-model="editForm.Timelength" size="small" :step="1" step-strictly ></el-input-number> 分钟
          </el-form-item>
            <el-form-item label="时长价格:" prop="TimelengthAmount" >
              <el-input size="small" v-model="editForm.TimelengthAmount" type="number" auto-complete="off" placeholder="请输入价格"  style="width: 215px"></el-input> 元
            </el-form-item>




        <el-form-item label="轮播图:" prop="mainImage">
            <div class="flexc-cen-x">
                <div class="list-img-box cursor">
                  <div v-if="img1 !== ''">
                    <img
                      :src="img1"
                    style="width: 121px; height: 81px"
                      alt="图片"
                       @click="uploadPicture('img1')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('img1')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                         <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>

                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <div class="list-img-box cursor" style="margin-left:10px">
                  <div v-if="img2 !== ''">
                    <img
                      :src="img2"
                      style="width: 121px; height: 81px"
                      alt="图片"
                        @click="uploadPicture('img2')"
                    />
                  </div>

                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('img2')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                       <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>

                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <div class="list-img-box cursor" style="margin-left:10px">
                  <div v-if="img3 !== ''">
                    <img
                      :src="img3"
                      style="width: 121px; height: 81px"
                      alt="图片"
                       @click="uploadPicture('img3')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('img3')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                    
                  <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
            </div>
            
        

          </el-form-item>
                  <el-form-item label="备注" prop="Note">
           <el-input type="textarea" :rows="2" placeholder="请输入简介" v-model="editForm.Note" style="width:90%"></el-input>
        </el-form-item>
        <el-form-item label="支付提醒:" prop="ispaytx" v-if="iscdyydx ==1" >
                <el-radio-group v-model="editForm.ispaytx">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="提醒内容:" prop="paytxinfo" v-if="editForm.ispaytx==1 && iscdyydx ==1"  >
              <el-input type="textarea" :rows="2" placeholder="请输入提醒内容" v-model="editForm.paytxinfo" style="width:90%"></el-input>
            </el-form-item>
        <!-- <el-form-item :label="WZXMName+'简介:'" prop="ProjectIntroduction">
           <el-input type="textarea" :rows="2" placeholder="请输入简介" v-model="editForm.ProjectIntroduction" style="width:90%"></el-input>
        </el-form-item> -->
        </el-form>
      </el-tab-pane>

        <el-tab-pane label="图文详情" name="third">
            <Editor :key="timer" v-show="activeName == 'third'" v-bind:value="editForm.GraphicDetails" v-model="editForm.GraphicDetails"  style="margin-bottom:150px;margin-top:-10px">
            </Editor>
        </el-tab-pane>
        <el-tab-pane label="预约设置" name="forth" >
          <el-form label-width="130px">
            <el-form-item :label="'开启'+name1+'资料:'" prop="isPreAboutInfo">
              <el-radio-group v-model="editForm.isPreAboutInfo" >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="name1+'资料:'" v-if="editForm.isPreAboutInfo == 1">
              <el-button bian type="text"  @click="openPreAbout()">编辑</el-button>
            </el-form-item>
            <div  v-for="(items,index) in editForm.ListPreAboutForms" v-if="items.state !=3 && editForm.isPreAboutInfo == 1" style="margin-bottom:15px;">
              <div>
                <span v-if="items.isbt == 1" style="margin-left:5%;color:red">*</span>
                <span v-if="items.isbt == 0" style="margin-left:5%;color:white">*</span>
                <span>{{items.Title}}<span v-if="items.fType == 1" ><i class="el-icon-s-order" style="margin-left:4px"></i>:</span>
                <span v-if="items.fType == 2"><i class="el-icon-s-grid" style="margin-left:4px"></i>：</span></span>
              </div>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>

        <div class="demo-drawer__footer flex-spc-x"  style="width:40%">
          <div>
         <el-button
           v-if="title == '修改' && q6 ==true"
            style="margin-left:20px"
            size="small"
            type="danger"
            @click="delForm()"  
            >删除</el-button
          >
          </div>
  <div>

          <el-button size="small" @click="closeDialog">取消</el-button>
          
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            @click="submitForm('editForm')"
            >保存</el-button
          >
  </div>
         
        </div>
    </el-drawer>
    <!-- </el-dialog> -->
    <el-dialog :title="title1" :visible.sync="passShow" width="40%" >
      <el-form label-width="120px" >
        <el-form-item :label="WZXMName+'类别'" prop="SiteTypeName">
          <el-input size="small" placeholder="请输入类别" v-model="SiteTypeName" auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="passShow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="subSiteTypeName()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择颜色" :visible.sync="colorShow" width="500px" >
        <div style="height:300px;overflow:auto;">
            <div class="bgColor" v-for="(item,index) in colorList" :style="{'background':item,'width':'80%','margin-top':'15px','margin-left':'10%'}" @click="toChooseColor(item)"> 
            </div>
        </div>
        
    </el-dialog>
    
    <el-dialog :title="name1+'资料'" :visible.sync="preShow" width="800px" >
      <div class="flex-spc-x" style="width:98%;margin-left:1%;height:400px">
        <div class="right" style="height:100%;width:27%" > 
            <div class="flex-xy"  style="margin-bottom:20px">通用格式</div>
            <el-button plain class="el-icon-s-order" @click="toadd('1')"> 文本</el-button>
            <el-button plain class="el-icon-s-grid" @click="toadd('2')"> 时间</el-button>
        </div>
        <div class="left flex-xy" style="width:73%;height:100%">
            <div class="mainTitle">
                <div class="" style="font-size:20px;margin-left:5px;margin-top:5px;font-weight:500">{{name1}}资料</div>
                <div  class="mian" style="margin-top:10px;width:100%" :key="timer" @dragover="dragover($event)">
                  <transition-group class="transition-wrapper" name="sort">
                    <div v-for="(items,index) in ListPreAboutForms" class="hen flex-xy" :key='items.length' v-if="items.state != 3" style="margin-top:10px"   
                      :draggable="true"
                      @dragstart="dragstart(items)"
                      @dragenter="dragenter(items,$event)"
                      @dragend="dragend(items,$event)"
                      @dragover="dragover($event)">
                      <div class="flex-spc-x" style="font-size:15px;width:100%;">
                        <span v-if="items.fType == 1" style="margin-left:5%">文本</span>
                        <span v-if="items.fType == 2" style="margin-left:5%">时间</span>
                        <i class="el-icon-delete-solid coBlue" style="margin-right:2%;font-size:15px" @click="todel(items,index)"></i>
                        <!-- <el-button size="mini" style="margin-right:10px" type="info" @click="todel(items,index)">删除</el-button> -->
                      </div>
                      <div class="flexc-cen-x"  style="margin-top:5px">
                        <el-select v-model="items.isbt" placeholder="选择" size="mini" style="width:80px">
                          <el-option
                            v-for="item in lay"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                        <el-input size="mini" v-model="items.Title" placeholder="请输入标题" style="width:350px;margin-left:10px"></el-input>
                      </div>
                     
                    </div>
                  </transition-group>
                  
                </div>
   
            </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="preShow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="save()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
              title="裁切封面"
              :visible.sync="cropperModel"
              width="1200px"
              center
            >
             <cropper-image
                :Name="cropperName"
                @uploadImgSuccess="handleUploadSuccess"
                ref="child"
                :key="timer"
              >
              </cropper-image> 
    </el-dialog>
            <!--查看大封面-->
    <el-dialog title="查看大封面" :visible.sync="imgVisible" center>
        <img
          :src="imgName"
          v-if="imgVisible"
          style="width: 100%"
          alt="查看"
        />
    </el-dialog>
     <el-dialog title="类别" :visible.sync="vipShow" width="600px" @click="vipShow = false">
       <div class="flex-spc-x" style="margin-top:-20px">
         <div></div>
          <el-button size="mini" type="primary" icon="el-icon-plus"  v-if="q1 == true"  @click="handlePassword()">添加{{WZXMName}}类别</el-button>
       </div>
        
      <el-table  :data="typeList" highlight-current-row v-loading="loading" size="mini"  element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
        <el-table-column  prop="SiteTypeName" label="类别名称">
            
        </el-table-column>
      <el-table-column align="center" label="操作" width="200" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handlePassword(scope.row)" >编辑</el-button>
          <el-button size="mini" type="info" v-if="q3 ==true" @click="toDel(scope.row)" >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
     </el-dialog>
  </div>
</template>

<script>

import CropperImage from "../../components/CropperImage";
import  Editor from '../../components/editor'

import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      title1:'',
      DianList:[],
      oldData:null, // 开始排序时按住的旧数据
      newData:null,// 拖拽过程的数据
      preShow:false,
      cropperModel: false,
      cropperName: "",
      colorShow:false,
      imgName: "",
      imgVisible: false,
      formValidate: {
        mainImage: "",
      },
      cardList:[],
      timer:'',
      value:'1',
      active:0,
      vipShow:false,
      colorList:[
          '#FEFF99',
          '#FBB0A1',
          '#BCFD84',
          '#95E2F5',
          '#928FD9',
          '#47D95E',
          '#E5D0C4',
          '#9c4b4b',
          '#db6a51',
          '#f5c856',
          '#75c090',
          '#ed707a',
          '#b0649a',
          '#d19fc9',
          '#8b9599',
          '#9c8088',
          '#a6c399',
          '#5b6fc1',
          '#9583b0',
          '#b0a763',
          '#da8e6d',
          '#b07187',
      ],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      q7:false,
      q8:false,
      IsPay:localStorage.getItem("IsPay"),
      iscdyydx:localStorage.getItem("iscdyydx"),

      
      hyIsPay:localStorage.getItem("hyIsPay"),
      spIsPay:localStorage.getItem("spIsPay"),
      gkIsPay:localStorage.getItem("gkIsPay"),
      hdIsPay:localStorage.getItem("hdIsPay"),
      xmIsPay:localStorage.getItem("xmIsPay"),
      typeName:'',
      RowTypeList:[],
      name:'全部',
      id:'',
      active:'',
      img1:'',
      img2:'',
      img3:'',
      activeName: 'first',
      SelectStoresID:localStorage.getItem("StoresID"),
      direction: "ltr",
      passShow:false,
      money:'',
      input:'',
      timer:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      sortSure:false,
      SiteTypeName:'',
      ListPreAboutForms:[],
      options:[],
      iszjyy:"",
      WZCDName: localStorage.getItem('WZCDName'), 
      lay:[
        {
          value:'1',
          label:'必填'
        },
            {
          value:'0',
          label:'选填'
        }
      ],
      // rowType:[
      //    {
      //     value:'1',
      //     label:'班课'
      //   },
      //       {
      //     value:'2',
      //     label:'私教'
      //   },
      //    {
      //     value:'3',
      //     label:'精品课'
      //   }
      // ],
      Pwd:'',
      typeList:[],
      Limits:[],
      editForm: {
        color:'#b0649a',
        Timelength:60,
        isjp:0,
        ishot:0,
        isPreAboutInfo:0,
        PayAmount:0,
        SiteName:'',
        isshelves:1,
        HeadUrl:'',
        Amount:0,
        SiteTypeID:'',
        CardIDs:'',
        isPay:0,
        iswkyy:'0',
        TimelengthAmount:0,
        token: localStorage.getItem('token'),
        ListPreAboutForms:[],
        ispaytx:0,
        paytxinfo:'',
      },
      // rules表单验证
      isCard:localStorage.getItem('isCard'),
      rules: {
        SiteName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        SiteTypeID:[{ required: true, message: '请选择类别', trigger:  'blur' }],
        HeadUrl: [{ required: true, message: '请选择分辨图', trigger: 'blur' }],
      
      },
  name1:'',
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Editor,
    Pagination,
    CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZCDName'), 
    this.WZPBName = localStorage.getItem('WZPBName')

    this.iszjyy = localStorage.getItem('iszjyy')
    this.name1 = '预约资料'
      if(localStorage.getItem('StoresType')== 1){
          this.typeName = '签到'
        
      }  else {
          this.typeName = '核销'
        
      }     
      if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 = true
          this.q7 = true
          this.q8 = true
      }
    this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
            if(items == 62){
              this.q1 = true
            }
            if(items == 63){
              this.q2 = true
            }
            if(items == 64){
              this.q3 = true
            }
            if(items == 65){
              this.q4 = true
            }
            if(items == 66){
              this.q5 = true
            }
            if(items == 67){
              this.q6 = true
            }
            if(items == 68){
              this.q7 = true
            }
          
    })

    this.getType()
    this.getList()
    this.getRowType()
    this.getCardType()
    this.getDianList()
    this.getCardList()
  
      // this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    toMain(row){
       this.$router.push({ 

          path: `/site/siteMain/${row.ID}`,

      })
    },
      handleClick(){
          this.getList()
      },
     toSetting(){
      this.getType()
      this.vipShow = true

    },
    toCard(){
          this.$router.push({ path: '/card/card'})
    },
    getRowType(){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
      }
  
      var that = this
      this.ajax('getListRowTypeSetting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         
                that.RowTypeList= res.data
    
          } 
       })
    },
    getCardList(){
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CardType:0
      }
  
      var that = this
      this.ajax('getListMemberCard.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         
                that.cardList= res.data
    
          } 
       })

    },
      changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
   this.getType()
    this.getList()
    this.getCardType()
    },
     getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
},
    save(){
      var list = Array.from(this.ListPreAboutForms)
      var  cd = false
      list.forEach(items => {
        if(items.Title == ''){
            cd = true
        }
      });
      if(cd == true){
          this.$message({
              duration:2000,
              message:'请输入标题'
          });
      } else {
          this.preShow = false
          this.editForm.ListPreAboutForms =  Array.from(this.ListPreAboutForms)
      
          for(var i = 0 ;i<this.editForm.ListPreAboutForms.length;i ++){
              this.editForm.ListPreAboutForms[i].sort = i       
          }
      }
      
     
     
    },
     dragstart(value) {
            this.oldData = value
        },

        // 记录移动过程中信息
        dragenter(value, e) {
            this.newData = value
            e.preventDefault()
        },

        // 拖拽最终操作
        dragend(value, e) {
            if (this.oldData !== this.newData) {
                let oldIndex = this.ListPreAboutForms.indexOf(this.oldData)
                let newIndex = this.ListPreAboutForms.indexOf(this.newData)
                let newItems = [...this.ListPreAboutForms]
                // 删除老的节点
                newItems.splice(oldIndex, 1)
                // 在列表中目标位置增加新的节点
                newItems.splice(newIndex, 0, this.oldData)
                this.ListPreAboutForms = [...newItems]
            }
        },


        // 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
        dragover(e) {
            e.preventDefault()
        },

    todel(items,index){
      if(items.isedit == 0){
           if(this.title == '添加'){
        this.ListPreAboutForms.splice(index, 1)
      } else {
        this.timer =  new Date().getTime()
        items.state = 3
      }
    } else {
      this.$message({
  
              duration:2000,
              message:'无法删除'
            });
    }
     
       
    },
    toadd(type){
      
        var list = {
          length:this.ListPreAboutForms.length,
          Title:'',
          fType:type,
          objID:this.editForm.ID,
          isbt:'1',
          state:1,
          objType:'3',
          isedit:0,
         
        }
     
      this.ListPreAboutForms.push(list)      
 
    },
    hover(items){
      items.show = true
      this.timer =  new Date().getTime()
      console.log(items.show)
      // console.log('1111')
    },
    UpRoll(items){
      items.show = false
      this.timer =  new Date().getTime()
 
        console.log(items.show)    
    },
    openPreAbout(){
      if(this.title == '修改'){
            for(var i= 0;i<this.editForm.ListPreAboutForms.length;i++ ){
                this.editForm.ListPreAboutForms[i].length = i
                this.editForm.ListPreAboutForms[i].state = 0
            }
      }
      this.ListPreAboutForms = this.editForm.ListPreAboutForms
      this.preShow = true
    },
    toTop(row){
      var data = { SelectStoresID:this.SelectStoresID,        

          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:row.ID,
          SelectStoresID:this.SelectStoresID
        }
        var that = this
        this.ajax('editProjectDesc.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
           
              that.getList()
             
            }

        })
 
    },
    toDown(row){
      var data = { SelectStoresID:this.SelectStoresID,        
         
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:row.ID,
         
        }
        var that = this
        this.ajax('editProjectAes.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
             
              that.getList()
             
            }

        })
    },
      toSort(){
          this.sortSure = true
    },
    getCardType(){
        var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
        }
        var that = this
          this.ajax('getListMemberCard.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
       
                // that.typeList = res.data
                //  loading.close();
          } 
       })
    
    },
    toChooseColor(item){
      this.editForm.color = item
      this.colorShow =false
    },
    toColor(){
      console.log(this.colorShow)
      this.colorShow = true
    },
    toAll(){
      this.active = ''
      this.name = '全部'
      this. pageparm={
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
      this.getList()
    },
    toChoose(item){
        this.active = item.ID
        console.log(item.ID)
        this.name = item.SiteTypeName
        this. pageparm={
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
        this.getList()
    },
    handlePassword(row){
          if (row != undefined && row != 'undefined') {
              this.title1 = '编辑类别'
              this.id= row.ID
              this.SiteTypeName = row.SiteTypeName
          } else {
              this.title1 = '添加类别'
               this.id= ''
              this.SiteTypeName =  ''
          }
 


      this.passShow = true

    },

subSiteTypeName(){
    if(this.SiteTypeName == ''){
             this.$message({
  
              duration:2000,
              message:'请输入类别'
            });
    }else {
        if(this.title1 == '添加类别'){
        var data = { 
                  SelectStoresID:this.SelectStoresID,        
                  token: localStorage.getItem("token"),
                  StoresID:localStorage.getItem("StoresID"),
                  SiteTypeName:this.SiteTypeName
              }
        var that = this
        this.ajax('addSiteType.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
                that.$message({
              type: "success",
              duration:2000,
              message:'添加成功'
            });
            that.getType()
            that.getList()
            that.passShow = false
                  // that.tableLoading = false
                  // that.typeList = res.data
                  //  loading.close();
            } 
        })
    
      } else {
         var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SiteTypeName:this.SiteTypeName,
          SiteTypeID:this.id
      }
      var that = this
      this.ajax('editSiteType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
            type: "success",
            duration:2000,
            message:'修改成功'
          });
           that.getType()
          that.getList()
          that.passShow = false
              
          } 
       })
    
      }
    }
},
delForm(){
this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          SiteID:this.editForm.ID,
        
        }
        var that = this
        this.ajax('delSite.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
              that.closeDialog()
              that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
},
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
       this.chongShow = true
      this.money = ''
    },
        getType(){
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
      }
      var that = this
      this.ajax('getListSiteType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.typeList = res.data
                //  loading.close();
          } 
       })
    
    },
    getList(){

    //  this.tableLoading = true
      var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:100,
          SiteTypeID:this.active
          // StaffTypeID:this.active
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListSite.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                 loading.close();
          } 

      })
  
    },
    // 获取公司列表

    uploadPicture(name) {
        this.timer = new Date().getTime()
      this.cropperName = name;
      this.cropperModel = true;
    },
    //图片上传成功后
    handleUploadSuccess(data) {
       this.cropperModel = false
      if(this.cropperName == 'KFQrCode'){
        this.editForm.KFQrCode = data.url

      }
      if(this.cropperName == 'HeadUrl'){
          this.editForm.HeadUrl = data.url
      }
      if(this.cropperName == 'img1'){
          this.img1 = data.url
      }
            if(this.cropperName == 'img2'){
          this.img2 = data.url
      }
            if(this.cropperName == 'img3'){
          this.img3 = data.url
      }

      this.cropperModel = false;
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    getInfo(row){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
           SiteID:row.ID
        }
        var that = this
        this.ajax('getSiteInfo.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {

              that.editForm = res.data
                that.editInfo(row)
              //  that.provinceList = res.data
            }

        })
    },
      editInfo(row){
        this.timer = new Date().getTime()
        if(this.editForm.CardIDs != ''){
              this.editForm.CardIDs = this.editForm.CardIDs.split(",")
          } else {
          
          }
this.editForm.isbxsc = Number(this.editForm.isbxsc) 
          this.editForm.isPreAboutInfo = Number(this.editForm.isPreAboutInfo) 
          this.editForm.ishot = Number(this.editForm.ishot) 
          this.editForm.isjp = Number(this.editForm.isjp) 
          this.editForm.isPay = Number(this.editForm.isPay) 
          this.editForm.ispaytx = Number(this.editForm.ispaytx) 

          this.editForm.isshelves = Number(this.editForm.isshelves) 
          var  that = this

            if(row.listSiteImg.length>0 && row.listSiteImg[0].ImgUrl !='' ){
                  that.img1 = row.listSiteImg[0].ImgUrl
                } else {
                  that.img1 =""
                }
                            if(row.listSiteImg.length>1 && row.listSiteImg[1].ImgUrl !=''){
    that.img2 = row.listSiteImg[1].ImgUrl
                }else {
                  that.img2 =""
                }
                              if(row.listSiteImg.length>2 && row.listSiteImg[2].ImgUrl !=''){
            that.img3 = row.listSiteImg[2].ImgUrl
                }else {
                  that.img3 =""
                }
                if(this.editForm.isPreAboutInfo == 1){
                  this.getPreAboutInfo()
                } else {
                this.editForm.ListPreAboutForms = []
            }
      },
    //显示编辑界面
    handleEdit: function(row) {
      if(this.typeList.length >0){
              this.activeName = 'first'
        this.timer = new Date().getTime()
     
      if (row != undefined && row != 'undefined') {
        if(this.q2 == true){
          this.title = '修改'
          this.getInfo(row)
           this.editFormVisible = true
        }

      } else {
        
        this.title = '添加'
        this.img1 = ''
        this.img2 = ''
        this.img3 = ''

        this.editForm = {
              RowTypeID:'',
              color:'#b0649a',
              Timelength:60,
              isjp:0,
              ishot:0,
              isPreAboutInfo:0,
              SiteName:'',
              isshelves:1,
              HeadUrl:'',
              Amount:0,
              SiteTypeID:'',
              CardIDs:'',
              isPay:0,
              iswkyy:'0',
              isbxsc:0,
              PayAmount:0,
              TimelengthAmount:0,
              Note:'',
              RowType:'',
              ispaytx:0,
              paytxinfo:'',
              ListPreAboutForms:[]
          }

        
        if(this.RowTypeList.length == 1){
           this.editForm.RowType = this.RowTypeList[0].RowType
           this.editForm.RowTypeID = this.RowTypeList[0].ID
        }
        if(this.typeList.length == 1){
           this.editForm.SiteTypeID = this.typeList[0].ID
        }
              this.editFormVisible = true
      }
      } else {
         this.$message({message: "请先添加类别"});
      }

    },
getPreAboutInfo(){
    var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:3,
          objID:this.editForm.ID
        }
        var that = this
        this.ajax('getListPreAboutForms.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {

              that.editForm.ListPreAboutForms = res.data

              //  that.provinceList = res.data
            }

        })
  
},
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.editForm.lbimgs = ''
      if(this.img1 !='' && this.img1  )
        this.editForm.lbimgs = this.editForm.lbimgs + this.img1 + ','
      if(this.img2 !='' && this.img2 )
        this.editForm.lbimgs = this.editForm.lbimgs   +this.img2  + ','
      if(this.img3 !='' && this.img3)
        this.editForm.lbimgs = this.editForm.lbimgs  + this.img3 

      this.$refs[editData].validate(valid => {
        if (valid) {
          var that = this
          this.RowTypeList.forEach(items => {
          
            if(items.ID == this.editForm.RowTypeID){
              this.editForm.RowType = items.RowType
              console.log('1111',this.editForm.RowType)
            }
          });
          // var ls  = [...this.ListPreAboutForms] 
            // console.log(this.ListPreAboutForms)
            var data = this.editForm
            if(this.editForm.CardIDs){
                var card = [...this.editForm.CardIDs]
               data.CardIDs =  card.join(",")
         
            }
         
            data.token=localStorage.getItem("token")
            data.SelectStoresID = this.SelectStoresID
            data.StoresID=localStorage.getItem("StoresID")
            console.log(data.ListPreAboutForms)
     
            if(this.title == '添加'){
              this.ajax('addSite.aspx',JSON.stringify(data),"POST",function(res){
                              if (res.orsuccess == "1") {

                                  that.$message({
                                    type: "success",
                                    message: "新建成功",duration:2000,
                                  });
                                  that.editFormVisible = false
                                  that.getList()
                                }

                            })

               

            }else {
             data.SiteID = this.editForm.ID

             this.ajax('editSite.aspx',JSON.stringify(data),"POST",function(res){
                     if (res.orsuccess == "1") {
                              that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000,
                                  });
                                  that.editFormVisible = false
                                  that.getList()
                                }                                 

                    })         

            }
        } else {
          return false
        }
      })
    
    },


    handlejie(row) {
      if(row.Isdisable == 0){
 this.$confirm('确定要禁用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.jie(row)
        })
        .catch(() => {
          
        })
      } else {
this.$confirm('确定要解禁吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.jie1(row)
        })
        .catch(() => {
          
        })
      }
 
     
    },

        toDel(row){
      
       this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          SiteTypeID:row.ID,
        
        }
        var that = this
        this.ajax('delSiteType.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
              that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
    // toDel(){
    //     this.$confirm('确定要删除吗?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //         this.delete(row)
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消删除'
    //       })
    //     })
    // },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.delete(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.sortSure = false,
      this.colorShow = false,
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
      this.preShow = false
    }
  }
}
</script>

<style scoped>
.mian{
  height: 300px;
  overflow: auto;
  overflow-x: hidden
}
.hen{
  width: 95%;
  border: 1px dashed #65a8ff;
  margin-left: 2.5%;
  padding-top:10px;
  padding-bottom: 10px;
}
.mainTitle{
  border-radius: 5px;
  width: 95%;
  height: 95%;
  background-color: white;
}
.left{
  background-color: #e0e0e0;
}
.jingp{
  width:50px;

  margin-left: 10px;
  font-size: 13px;
}
.kuai{
  margin-left: 10px;
  border-radius: 20px;
  width: 20px;
  height: 20px;
}
.bgColor{
  width:215px;
  height:30px;
  border:1px solid #808080;
  margin-top:5px;
  border-radius: 4px;
}
.main{
  position: absolute;
}
.content{
  font-size: 13px;
  color: #999;
  line-height: 20px;
}
.titleMain{
    font-size: 14px;
    color: #191919;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.offline___NHq4e1 {
    position: absolute;
    top: -1px;
    left: -4px;
    padding: 0.5px 4px 0.5px 4px;

    background: rgba(255, 101, 247, 0.04);
    border-radius: 0 8px 0 8px;
    font-size: 12px;
    text-align: center;
    line-height: 20px;

}
.offline___NHq4e {
    position: absolute;
    top: -1px;
    right: -1px;
    padding: 0.5px 4px 0.5px 4px;
    /* width: 64px; */
    /* height: 22px; */
    background: rgba(255, 101, 247, 0.04);
    border-radius: 0 8px 0 8px;
    border: 1px solid rgba(187, 14, 255, 0.2);
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    color: #b336fc;
}
.box{
  position: relative;
    width: calc((100% - 80px)/4);
    padding: 20px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
    height: 130px;
}
@media screen and ( max-width: 1400px ) {
  .box{
    cursor: pointer;
    width: calc((100% - 60px)/3);
  }
}
.box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
}
.shadow:hover {
    border:1px solid #409EFF;border-radius:2px
}
.shadow {
    border:1px solid #ffffff;border-radius:2px
}

.xiang{
    padding: 1px 4px  1px 4px;
    background-color: #f7f7f7;
    border:1px solid #bbbbbb;
    border-radius: 3px;
    font-size: 10px;
    color:#bbbbbb;
}
  
/* .el-switch__core::after{
 height: 12px !important;
 width :12px !important;
} */
   
.title{
    margin-top: 10px;
    height: 30px;
    font-size: 13px;
    font-weight: bolder;
    border-radius: 3px;
    border-left: 5px solid #334157;

}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/site/siteList.vue